export default __webpack_public_path__ + "static/media/spooky_hill_s3.be5d8813.png";